import {
  INode,
  IRenderContext,
  NodeStyleBase,
  RectangleNodeStyle,
  ShapeNodeShape,
  ShapeNodeStyle,
  Stroke,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import { disablePointerEvents } from './util';
import { getHighlightColor } from 'tabview/graphComponent/getHighlightColor';
import { colors } from '@ardoq/design-tokens';
import {
  MODERNIZED_BLOCK_DIAGRAM_CORNER_RADIUS as CORNER_RADIUS,
  MODERNIZED_BLOCK_DIAGRAM_SELECTION_STROKE_WIDTH as STROKE_WIDTH,
} from './modernized/consts';

const createShapeNodeStyle = (node: INode, isModern: boolean) =>
  isModern
    ? new RectangleNodeStyle({
        fill: 'transparent',
        stroke: new Stroke(colors.grey950, STROKE_WIDTH),
        cornerSize: CORNER_RADIUS + STROKE_WIDTH / 2,
      })
    : new ShapeNodeStyle({
        fill: getHighlightColor(node.tag),
        stroke: 'transparent',
        shape: ShapeNodeShape.ELLIPSE,
      });

export class NodeSelectionStyle extends NodeStyleBase {
  constructor(private isModern: boolean) {
    super();
  }
  protected override createVisual(
    context: IRenderContext,
    node: INode
  ): Visual | null {
    const shapeNodeStyle = createShapeNodeStyle(node, this.isModern);
    const result = shapeNodeStyle.renderer
      .getVisualCreator(node, shapeNodeStyle)
      .createVisual(context);
    if (result instanceof SvgVisual) {
      disablePointerEvents(result);
    }
    return result;
  }
  protected override updateVisual(
    context: IRenderContext,
    oldVisual: Visual,
    node: INode
  ): Visual | null {
    const shapeNodeStyle = createShapeNodeStyle(node, this.isModern);
    const result = shapeNodeStyle.renderer
      .getVisualCreator(node, shapeNodeStyle)
      .updateVisual(context, oldVisual);
    if (result instanceof SvgVisual) {
      disablePointerEvents(result);
    }
    return result;
  }
}
